import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';



// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowRight, faBars, faChevronDown, faXmark, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

class FooterWeb extends Component {
    render() {
        return (
            <footer>
            <div className='container-98'>
                <div className='row m-0 footer-top align-items-stretch justify-content-center'>
                    <div className='col-lg-4 col-md-12 col-sm-12 col-12'>
                       <a href="#">
                        <img
                            src={require("../../src/assets/images/website/footerlogo.webp")}
                            alt="Klinicq Footer Logo"
                            className="footerLogo mb-3"
                            width="225"
                            height="100"
                            loading="lazy"
                            fetchPriority="low"
                            decoding="async"
                        />
                        </a>

                        {/* <p>131, Rashtriya Vidyalaya Rd, Vishweshwarapura, <br/>Basavanagudi, Bengaluru, Karnataka 560004</p> */}
                        <p>514 A,Min Nagar, Panickampatti Post <br/>Palladam,Tiruppur,TamilNadu-641664</p>
                        {/* <p>Electronic Clinical Management System <br/>(e CMS) application. It is user-friendly,<br/> convenient, comprehensive, and integrated to <br/>manage all hospital </p> */}
                        {/* <div class="download-btn">
                            <a target="_blank" href="#" class="app-store-btn">
                                <img src={require("../../src/assets/images/website/apple.svg")} className='' />
                                <span>Download on the</span>
                                App Store
                            </a>
                            <a target="_blank" href="#" class="google-play-btn">
                                <img src={require("../../src/assets/images/website/android.svg")} className='' />
                                <span>Get on it</span>
                                Google Play
                            </a>
                        </div> */}
                          <ul className='social-logo p-0'>
                            {/* <li><a href='https://www.instagram.com/klinicq/' target='_blank'><img src={logo1} width={24} height={24} /></a></li>
                            <li><a href='https://www.facebook.com/KlinicQ/' target='_blank'><img src={logo2} width={24} height={24} /></a></li>
                            <li><a href='https://twitter.com/KlinicQ' target='_blank'><img src={logo3} width={24} height={24} /></a></li>
                            <li><a href='https://youtu.be/qPbaZgYzeYs?si=qCbHr55Gg-8j_pbX' target='_blank'><img src={logo4} width={24} height={24} /></a></li> */}
                            <li><a href='https://www.instagram.com/klinicq/' target='_blank'><img src={require("../../src/assets/images/website/social1.png")} width={24} height={24} /></a></li>
                            <li><a href='https://www.facebook.com/KlinicQ/' target='_blank'><img src={require("../../src/assets/images/website/social2.png")} width={24} height={24} /></a></li>
                            <li><a href='https://twitter.com/KlinicQ' target='_blank'><img src={require("../../src/assets/images/website/social6.png")} width={24} height={24} /></a></li>
                            <li><a href='https://youtu.be/qPbaZgYzeYs?si=qCbHr55Gg-8j_pbX' target='_blank'><img src={require("../../src/assets/images/website/social4.png")} width={24} height={24} /></a></li>
                        </ul>
                        <div id="download" class="download-btn2">
  <a target="_blank" href="https://apps.apple.com/us/app/klinicq-health/id6447692881">
    <img src={require("../../src/assets/images/website/apple.svg")} alt="Download Klinicq Health app on Apple App Store"/>
    <span>Download on the</span> App Store
  </a>
  <a target="_blank" href="https://play.google.com/store/apps/details?id=com.nucleo.klinicQ&hl=en_IN" class="ml-2">
    <img src={require("../../src/assets/images/website/android1.png")} alt="Get Klinicq Health app on Google Play Store"/>
    <span>Get it on</span> Google Play
  </a>
</div>

                         {/* <button type='button' className='btn_sec mb-3'  >Make An Appoinment<i class="fa-solid fa-arrow-right-long ml-2" style={{color: '#FFF'}}></i> </button> */}
                      
                    </div>
                    <div className='col-lg-2 col-md-4 col-sm-4 col-6 py-3 '>
                        <ul className='footer-list p-0  float-md-none'>
                            <li className='content-title'style={{color:'#0C5B98'}}>Platform</li>
                            <li>
                                <NavLink exact to={{ pathname: '/aboutus' }} className='text-decoration-none text-white'>
                                    About Us
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/patientmanagment' }} className='text-decoration-none text-white'>
                                    For Patient
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/doctormanagment' }} className='text-decoration-none text-white'>
                                For Doctor
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/hospitalmanagment' }} className='text-decoration-none text-white'>
                                    For Hospital
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/pharmacymanagment' }} className='text-decoration-none text-white'>
                                    For Pharmacy
                                </NavLink>
                            </li>
                            {/* <li>
                                <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                                Careers
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                                Documentation
                                </NavLink>
                            </li>

                            <li>
                                <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                                Plans & Pricing
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                                Papers
                                </NavLink>
                            </li> */}
                          
                        </ul>
                    </div>
                    
                    <div className='col-lg-2 col-md-4 col-sm-4 col-6 py-3'>
                        <ul className='footer-list p-0  float-md-none'>
                            <li className='content-title'style={{color:'#0C5B98'}}>Company</li>
                           
                            <li>
                                <NavLink exact to={{ pathname: '/webcontact' }} className='text-decoration-none text-white'>
                                Careers 
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/webcontact' }} className='text-decoration-none text-white'>
                                Contact Us
                                </NavLink>
                            </li>
                            {/* <li>
                                <NavLink exact to={{ pathname: '/terms' }} className='text-decoration-none text-white'>
                                Terms of service
                                </NavLink>
                            </li> */}
                            <li>
                                <a
                                    href="/terms"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none text-white"
                                >
                                    Terms of Service
                                </a>
                            </li>
                            {/* <li>
                                <NavLink exact to={{ pathname: '/privacy_policy' }} className='text-decoration-none text-white'>
                                Privacy and Policy
                                </NavLink>
                            </li> */}
                            <li>
                                <a
                                    href="/privacy_policy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none text-white"
                                >
                                    Privacy and Policy
                                </a>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                                Cookies
                                </NavLink>
                            </li>
                            {/* <li>
                                <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                                Blog
                                </NavLink>
                            </li> */}
                            
                            {/* <li><a href='https://webbitech.co.in/REACT-JS/klinicq/benefits' className='text-decoration-none text-white'>Careers</a></li>
                            <li><a href='https://webbitech.co.in/REACT-JS/klinicq/feature' className='text-decoration-none text-white'>Documentation</a></li>
                            <li><a href='https://webbitech.co.in/REACT-JS/klinicq/benefits' className='text-decoration-none text-white'>Plans & Pricing</a></li>
                            <li><a href='https://webbitech.co.in/REACT-JS/klinicq/bookusappointemnt' className='text-decoration-none text-white'>Papers</a></li>
                            <li><a href='https://webbitech.co.in/REACT-JS/klinicq/hospitals' className='text-decoration-none text-white'>Blog</a></li>
                            <li><a href='https://webbitech.co.in/REACT-JS/klinicq/contact' className='text-decoration-none text-white'>Contact</a></li> */}
                        </ul>
                    </div>

                    <div className='col-lg-2 col-md-4 col-sm-4 col-6 py-3'>
        <ul className='footer-list p-0 float-md-none'>
            <li className='content-title' style={{ color: '#0C5B98' }}>ContactUs</li>
            {/* <li>
                <span className='text-white'>+1 (234) 567-8901</span>
            </li> */}
            {/* <li>
                <span className='text-white'><a href='mailto:email1@example.com' className='text-decoration-none text-white'>mail@klinicq.com</a></span>
            </li> */}
            <li>
                <span className='text-white'><a href='/webcontact' className='text-decoration-none text-white'>info@nucleosws.com</a></span>
            </li>
            {/* <li>
                <span className='text-white'><a href='https://www.klinicq.com' className='text-decoration-none text-white' target='_blank' rel='noopener noreferrer'>www.Klinicq.com</a></span>
            </li> */}
            <li>
                <span className='text-white'><a href='/webcontact' className='text-decoration-none text-white' target='_blank' rel='noopener noreferrer' >Sales:+91 8015774643</a></span>
            </li>
        </ul>
    </div>

                    {/* <div className='row'>  */}
        <div className='col-lg-2 col-md-4 col-sm-4 col-6 py-3'>
            <ul className='footer-list p-0 float-md-none'>
                <li className='content-title' style={{ color: '#0C5B98' }}>Media</li>
                <li>
                    <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                        Blogs
                    </NavLink>
                </li>
                <li>
                    <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                        Documentation
                    </NavLink>
                </li>
                <li>
                    <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                        Paperless
                    </NavLink>
                </li>
               
            </ul>
        </div>
    {/* </div> */}
    <div className='row'>
    
    </div>
                    {/* <div className='col-lg-2 col-md-4 col-sm-4 col-6 py-3'>
                        <ul className='footer-list p-0 float-lg-end float-md-none'>
                            <li className='content-title d-lg-block d-md-block d-sm-block d-none  mb-4'></li>
                            <li><a href='https://webbitech.co.in/REACT-JS/klinicq/appointment' className='text-decoration-none text-white'>Blog</a></li>
                            <li><a href='https://webbitech.co.in/REACT-JS/klinicq/contact' className='text-decoration-none text-white'>Contact </a></li>
                            <li><a href='https://webbitech.co.in/REACT-JS/klinicq/doctor' className='text-decoration-none text-white'>For doctor</a></li>
                            <li><a href='https://webbitech.co.in/REACT-JS/klinicq/hospitals' className='text-decoration-none text-white'>For hospital</a></li>
                        </ul>
                    </div> */}
                </div>
            </div>
            <div className='footer-bottom-layout1'>
            <div className='container-95'>
                {/* <div className='row m-0 py-3 footer-bottom align-items-stretch justify-content-start'>
                <div className='col-lg-4 col-12 '>
                        <ul id="footer-menu">
                            <li>Terms of service</li>
                            <li>Privacy Policy</li>
                            <li>Cookies</li>
                        </ul>
                    </div> */}
                    {/* <div className='col-lg-12 col-12 text-lg-end text-center'>
                        <a href='#' className='text-decoration-none text-white'><p>Copyright © 2025, Nucleo Software Solutions. All rights reserved.</p></a> */}
                    {/* </div> */}
                    
                {/* </div> */}
                <div className='col-lg-12 col-12 text-lg-end text-center'>
                <a href='#' className='text-decoration-none text-white'>
                    <p>
                    Copyright © {new Date().getFullYear()}, Nucleo Software Solutions. All rights reserved.
                    </p>
                </a>
                </div>

            </div>
            </div>
          
        </footer>
        )}};
        export default FooterWeb;
       